import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Header, HubSidebar } from '../../components';
import { withRouter } from 'react-router-dom';
import { validateAccess } from '../../session';
import BookingCalendars from './BookingCalendars';
import BookingTypes from './BookingTypes';
import Bookings from './Bookings';

class BookingsHub extends Component {
  state = {
    selectedSection: 'Bookings',
  };

  canManageAllBookings = () => {
    return validateAccess(this.props.auth.site, 'bookings', this.props.auth);
  };

  canManageAssignedBookings = () => {
    return validateAccess(this.props.auth.site, 'assignedBookings', this.props.auth);
  };

  hasBookingPermissions = () => {
    return this.canManageAllBookings() || this.canManageAssignedBookings();
  };

  renderLeftBar() {
    const sections = [];

    // Only show if user has any booking permissions
    if (!this.hasBookingPermissions()) {
      return <HubSidebar sections={sections} />;
    }

    const bookingItems = [];
    
    // Add new booking button for all authorized users
    bookingItems.push({
      type: 'newButton',
      text: 'New Booking',
      buttonType: 'primary',
      onClick: () => {
        this.props.history.push(`/bookings/booking`);
      },
    });
    
    // Add block time button for all authorized users
    bookingItems.push({
      type: 'newButton',
      text: 'Block Time',
      buttonType: 'outlined',
      onClick: () => {
        this.props.history.push(`/bookings/blockout`);
      },
    });
    
    // Add view bookings for all authorized users
    bookingItems.push({
      type: 'navItem',
      text: 'View Bookings',
      icon: 'eye',
      isFontAwesome: true,
      selected: this.state.selectedSection === 'Bookings',
      onClick: () => {
        this.setState({ selectedSection: 'Bookings' });
      },
    });
    
    sections.push({
      title: 'Bookings',
      items: bookingItems,
    });

    // Only show Calendars section for full booking admins
    if (this.canManageAllBookings()) {
      const calendarItems = [];
      calendarItems.push({
        type: 'newButton',
        text: 'New Calendar',
        buttonType: 'outlined',
        onClick: () => {
          this.props.history.push(`/bookings/calendar`);
        },
      });
      calendarItems.push({
        type: 'navItem',
        text: 'View Calendars',
        icon: 'eye',
        isFontAwesome: true,
        selected: this.state.selectedSection === 'Calendars',
        onClick: () => {
          this.setState({ selectedSection: 'Calendars' });
        },
      });
      sections.push({
        title: 'Calendars',
        items: calendarItems,
      });
    }

    // Only show Booking Types section for full booking admins
    if (this.canManageAllBookings()) {
      const typeItems = [];
      typeItems.push({
        type: 'newButton',
        text: 'New Booking Type',
        buttonType: 'outlined',
        onClick: () => {
          this.props.history.push(`/bookings/type`);
        },
      });
      typeItems.push({
        type: 'navItem',
        text: 'View Booking Types',
        icon: 'eye',
        isFontAwesome: true,
        selected: this.state.selectedSection === 'BookingTypes',
        onClick: () => {
          this.setState({ selectedSection: 'BookingTypes' });
        },
      });
      sections.push({
        title: 'Booking Types',
        items: typeItems,
      });
    }

    return <HubSidebar sections={sections} />;
  }

  renderRight() {
    // Check permissions before rendering components
    if (!this.hasBookingPermissions()) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '400px',
          flexDirection: 'column',
          textAlign: 'center'
        }}>
          <h3>Access Denied</h3>
          <p>You do not have permission to access the booking management system.</p>
        </div>
      );
    }

    if (this.state.selectedSection === 'Bookings') {
      return <Bookings />;
    }
    if (this.state.selectedSection === 'Calendars' && this.canManageAllBookings()) {
      return <BookingCalendars />;
    }
    if (this.state.selectedSection === 'BookingTypes' && this.canManageAllBookings()) {
      return <BookingTypes />;
    }
    return null;
  }

  render() {
    return (
      <div className="hub-wrapperContainer">
        {this.renderLeftBar()}
        <div className="hub-headerContentWrapper">
          <Header />
          <div className="hub-contentWrapper">{this.renderRight()}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { auth } = state;
  return { auth };
};

export default connect(mapStateToProps, {})(withRouter(BookingsHub));
